/**
 * @fileoverview Interfaz para repositorios de autenticación
 * Define el contrato que deben implementar los adaptadores de autenticación
 */

/**
 * @interface IAuthRepository
 * @description Puerto secundario para servicios de autenticación
 * Siguiendo el patrón Ports & Adapters (Arquitectura Hexagonal)
 */
export default class IAuthRepository {
  /**
   * Inicia sesión con token personalizado
   * @param {string} token - Token de autenticación personalizado
   * @returns {Promise<Object>} Credenciales del usuario autenticado
   * @throws {Error} Si la autenticación falla
   */
  async signInWithCustomToken(token) {
    throw new Error('Method not implemented');
  }
  
  /**
   * Cierra la sesión del usuario actual
   * @returns {Promise<void>}
   */
  async signOut() {
    throw new Error('Method not implemented');
  }
  
  /**
   * Inicia el flujo OAuth con proveedor externo
   * @param {string} provider - Identificador del proveedor (tiendanube, google, etc)
   * @returns {Promise<string>} URL de redirección para iniciar OAuth
   */
  async getAuthProviderUrl(provider) {
    throw new Error('Method not implemented');
  }
  
  /**
   * Obtiene el token de autenticación actual para API calls
   * @returns {Promise<string>} Token de autenticación
   * @throws {Error} Si no hay sesión activa o el token no puede ser recuperado
   */
  async getIdToken() {
    throw new Error('Method not implemented');
  }
  
  /**
   * Verifica si hay una sesión activa
   * @returns {Promise<boolean>} True si hay sesión activa
   */
  async isAuthenticated() {
    throw new Error('Method not implemented');
  }
  
  /**
   * Se suscribe a cambios en el estado de autenticación
   * @param {Function} callback - Función a llamar cuando cambia el estado
   * @returns {Function} Función para cancelar la suscripción
   */
  onAuthStateChanged(callback) {
    throw new Error('Method not implemented');
  }
  
  /**
   * Refresca el token de autenticación
   * @returns {Promise<string>} Nuevo token de autenticación
   * @throws {Error} Si el token no puede ser refrescado
   */
  async refreshToken() {
    throw new Error('Method not implemented');
  }

  /**
   * Verifica si el token está expirado o expiará pronto
   * @param {number} [threshold=5] - Minutos antes de expiración para considerar como "pronto"
   * @returns {Promise<boolean>} True si el token está expirado o expirará pronto
   */
  async isTokenExpired(threshold = 5) {
    throw new Error('Method not implemented');
  }
}

// Exportado con ES Modules (export default) al inicio de la clase
